export const CARD_SIZES = { width: 170, height: 230 };
export const DECK_SIZE = 15;
export const API_PAGE_SIZE = 10;

export const BASE_URL = "https://picsum.photos", target="_blank", rel="noopener noreferrer" ;

export const GAME_STATUS = {
  IN_PROGRESS: "IN_PROGRESS",
  LOADING: "LOADING",
  CREATING: "CREATING",
  CHECKING: "CHECKING",
  RESETTING: "RESETTING",
  FINISHED: "FINISHED"
};

export const CARD_STATUS = {
  SELECTED: "SELECTED",
  MATCHED: "MATCHED",
  HIDDEN: "HIDDEN"
};

